<template>
    <div>
        <div class="moduleNotesDeFrais">
            <!--Liste des notes de frais-->
            <div>
              <el-table
                :data="notesDeFraisList"
                style="width: 100%">
                    <el-table-column
                    fixed
                    prop="ref"
                    label="Réf."
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="dateDeb"
                    label="Date début"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="dateFin"
                    label="Date fin"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="dateValidation"
                    label="Date validation"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="date"
                    label="Adresse"
                    width="300">
                    </el-table-column>
                    <el-table-column
                    prop="zip"
                    label="Zip"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="Opérations"
                    width="120">
                    <template slot-scope="scope">
                        <el-button @click="handleClick" type="text" size="small">Detail</el-button>
                        <el-button type="text" size="small">Editer</el-button>
                    </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>   
</template>

<script>
import script from '../../../script/script_notesDeFrais.js';
var moment = require('moment')

export default {
  watch: {
  },
  data() {
    return {
        notesDeFraisList: [],
    }
  },
  mounted:function(){
    this.verifyRight();
  },
  methods: {
    verifyRight: script.verifyRight,
  },
  components: {
    
  },
  computed:{
    info(){
      return this.$store.state.info
    },
  }
  
}
</script>

<style scoped>

</style>
